
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bUM6a", function(module, exports) {

$parcel$export(module.exports, "EndOfTrialMessageSharedGlobalComponent", () => $c6fe7d5433dc8f95$export$d575643e40b02bf0);

var $2iMSn = parcelRequire("2iMSn");

var $eUqFw = parcelRequire("eUqFw");

var $bHRuU = parcelRequire("bHRuU");
var $f9KE2 = parcelRequire("f9KE2");
var $9FEvp = parcelRequire("9FEvp");

var $iWLL0 = parcelRequire("iWLL0");

var $7ZZxN = parcelRequire("7ZZxN");

var $5ge6s = parcelRequire("5ge6s");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $79xbN = parcelRequire("79xbN");

var $3qf87 = parcelRequire("3qf87");

var $cPEpP = parcelRequire("cPEpP");

var $1JlVa = parcelRequire("1JlVa");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $g4G5S = parcelRequire("g4G5S");

var $ejxbt = parcelRequire("ejxbt");

var $56uMT = parcelRequire("56uMT");

var $8Kzvy = parcelRequire("8Kzvy");
const $c6fe7d5433dc8f95$export$e4cfe87fe34415bd = (environment, variables)=>(0, $iWLL0.fetchQuery)(environment, (0, $2iMSn.default), variables).toPromise().then((data)=>{
        const tenantContexts = data?.tenantContexts || [];
        const entitlement = tenantContexts[0]?.entitlementInfo?.entitlement;
        const ccpTrialLength = entitlement?.offering?.trial?.lengthDays;
        // firstPreDunningEndTimestamp is returned as microseconds as opposed to milliseconds
        const firstPreDunningEndTimestampMicroseconds = entitlement?.preDunning?.firstPreDunningEndTimestamp;
        if (!ccpTrialLength || !firstPreDunningEndTimestampMicroseconds) return null;
        const preDunningEndTimestamp = firstPreDunningEndTimestampMicroseconds / 1000;
        const trialEndTimestamp = (0, $f9KE2.default)((0, $9FEvp.default)(new Date(preDunningEndTimestamp), 14));
        const trialStartTimestamp = (0, $f9KE2.default)((0, $9FEvp.default)(new Date(trialEndTimestamp), ccpTrialLength));
        return {
            preDunningEndTimestamp: preDunningEndTimestamp,
            trialEndTimestamp: trialEndTimestamp,
            trialStartTimestamp: trialStartTimestamp
        };
    });
const $c6fe7d5433dc8f95$export$d575643e40b02bf0 = ()=>{
    const relayEnvironment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const { data: project } = (0, $cPEpP.useProject)();
    const { openModal: openModal } = (0, $eUqFw.useContext)((0, $3qf87.ModalContext));
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT));
    const entitlementDetails = productKey && productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS';
    const edition = projectType && (0, $6WXNs.getEditionForProject)(projectType, appEditions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: { load: load } } = (0, $6j4bv.useEntryPoint)((0, $1JlVa.editionAwarenessTrialModalEntryPoint), {
        cloudId: cloudId,
        productKey: productKey,
        jiraProjectType: (0, $7ZZxN.convertToJiraProjectType)((0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)),
        jiraApplicationKey: (0, $eIp1n.getApplicationKeyForProject)((0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT))
    });
    const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('end_of_trial_ep_message_jpd');
    const endOfTrialMessageCohort = endOfTrialMessageConfig.get('cohort', 'not-enrolled');
    const isEnrolled = endOfTrialMessageCohort !== 'not-enrolled';
    const shouldFetchPreDunning = isEnrolled && edition === (0, $6WXNs.STANDARD_EDITION) && projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT) && billingSourceSystem === 'CCP' && !entitlementDetails?.trialEndTime;
    const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, (0, $ejxbt.STARGATE_URL)), [
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const fetchPreDunningAndShowModal = async ()=>{
            if (shouldFetchPreDunning) {
                const endOfTrialMessageData = await $c6fe7d5433dc8f95$export$e4cfe87fe34415bd(relayEnvironment, {
                    cloudId: cloudId,
                    hamsProductKey: productKey
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'endOfTrialMessageData fetched', {
                    cloudId: cloudId,
                    productKey: productKey,
                    endOfTrialMessageData: endOfTrialMessageData
                });
                if (endOfTrialMessageData) {
                    const preDunningDaysLeft = (0, $bHRuU.default)(new Date(endOfTrialMessageData.preDunningEndTimestamp), new Date());
                    const eotmAudience = (0, $8Kzvy.getEndOfTrialMessageAudience)(preDunningDaysLeft);
                    const shouldShowModal = eotmAudience && await coordinationClient.start(eotmAudience);
                    if (shouldShowModal) {
                        fireStatsigExperimentExposure();
                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'endOfTrialMessaging', {
                            cohort: endOfTrialMessageCohort,
                            growthInitiative: 'transmuters',
                            projectType: projectType,
                            edition: edition
                        });
                        if (endOfTrialMessageCohort === 'variation') {
                            load();
                            openModal(({ onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                                    id: "endOfTrialMessageModalContainer",
                                    entryPointReferenceSubject: entryPointReferenceSubject,
                                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $56uMT.ModalSkeleton), {
                                        onClose: onClose
                                    }),
                                    runtimeProps: {
                                        onClose: onClose,
                                        projectType: (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT),
                                        edition: edition,
                                        endOfTrialMessageData: endOfTrialMessageData
                                    }
                                }));
                            coordinationClient.stop(eotmAudience);
                        }
                    }
                }
            }
        };
        fetchPreDunningAndShowModal();
    }, [
        cloudId,
        coordinationClient,
        createAnalyticsEvent,
        edition,
        endOfTrialMessageCohort,
        entryPointReferenceSubject,
        fireStatsigExperimentExposure,
        load,
        openModal,
        productKey,
        projectType,
        relayEnvironment,
        shouldFetchPreDunning
    ]);
    return null;
};

});
parcelRegister("2iMSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe9689bfc7d7d7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fbb1f233671875144f529ed315209946>>
 * @relayHash 841a5154019e1668c168f2346349a3d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f8b995e9fe1a9e4169c0a0204d20139cf593bee34f98e3ab1c3aa1269eb7785
const $bfe9689bfc7d7d7a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "AND": [
                    {
                        "inTrialOrPreDunning": true
                    }
                ]
            }
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CcpOfferingTrial",
                "kind": "LinkedField",
                "name": "trial",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lengthDays"
                    }
                ]
            }
        ],
        "type": "CcpOffering"
    }, v5 = {
        "kind": "ScalarField",
        "name": "firstPreDunningEndTimestamp"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "offering",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "offering",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6f8b995e9fe1a9e4169c0a0204d20139cf593bee34f98e3ab1c3aa1269eb7785",
            "metadata": {},
            "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bfe9689bfc7d7d7a$var$node.hash = "2b745a126dfb19c41fa6d1eb5904c34f";
var $bfe9689bfc7d7d7a$export$2e2bcd8739ae039 = $bfe9689bfc7d7d7a$var$node;

});

parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $9RC8H = parcelRequire("9RC8H");

var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition){
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && (0, $1ybV0.ff)('post-office_enable_jira_choreographer');
        const coordinationOptions = {
            enableChoreographer: enableChoreographer
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $9RC8H.MessageDeliveryStatus).STARTED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $9RC8H.MessageDeliveryStatus).STOPPED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $9RC8H.MessageDeliveryStatus).STARTED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $9RC8H.MessageDeliveryStatus).STOPPED : (0, $9RC8H.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children);
}

});
parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);

var $eI5EY = parcelRequire("eI5EY");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return (0, $eI5EY.fg)('po-jira-choreographer-api-integration') ? !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType) : false;
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});



parcelRegister("1JlVa", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessTrialModalEntryPoint", () => $a8110d5cf72f3ec9$export$de2f955c8fd39788);

var $hsi1O = parcelRequire("hsi1O");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a8110d5cf72f3ec9$export$de2f955c8fd39788 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("jhrVn")), {
        moduleId: "3928dd3c"
    }),
    // @ts-expect-error - JiraApplicationKey in AGG schema does not support CUSTOMER_SERVICE
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, jiraProjectType: jiraProjectType, jiraApplicationKey: jiraApplicationKey })=>({
            extraProps: {
                productKey: productKey
            },
            entryPoints: {},
            queries: {
                editionAwarenessTrialModalQueryRef: {
                    parameters: (0, $hsi1O.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: productKey,
                        projectType: jiraProjectType,
                        jiraApplicationKey: jiraApplicationKey
                    }
                }
            }
        })
});

});
parcelRegister("hsi1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b3391d5882a6fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b4e6fdfd2cb15e9aefca9f120ff0a5b5>>
 * @relayHash d8c6996056289dd1af9b7a4881e29284
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd9739500a7cb7d558a70beaef0d095bc7345593dbb74847c1fd54be12d0506f
const $72b3391d5882a6fe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "cd9739500a7cb7d558a70beaef0d095bc7345593dbb74847c1fd54be12d0506f",
        "metadata": {},
        "name": "main_EditionAwarenessTrialModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $72b3391d5882a6fe$export$2e2bcd8739ae039 = $72b3391d5882a6fe$var$node;

});

parcelRegister("jhrVn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('c9VNC')
        ]);
        const value = parcelRequire('579gd');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("c9VNC")
    ]).then(()=>parcelRequire('579gd'));
}

});


parcelRegister("g4G5S", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $c8efb20e27e18352$export$e02d6385b5d47f5d);

var $gd0Sp = parcelRequire("gd0Sp");
const $c8efb20e27e18352$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

parcelRegister("56uMT", function(module, exports) {

$parcel$export(module.exports, "ModalSkeleton", () => $8c0b5703c647f8ca$export$ba38383f4d71feb1);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $1zbEq = parcelRequire("1zbEq");
const $8c0b5703c647f8ca$export$ba38383f4d71feb1 = ({ onClose: onClose, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: 968,
        height: 576
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null));

});

parcelRegister("8Kzvy", function(module, exports) {

$parcel$export(module.exports, "getEndOfTrialMessageAudience", () => $07630406621a6851$export$35c002d8cb752227);

var $ejxbt = parcelRequire("ejxbt");
const $07630406621a6851$export$35c002d8cb752227 = (preDunningDaysLeft)=>{
    if (preDunningDaysLeft >= 0 && preDunningDaysLeft <= 13) return (0, $ejxbt.END_OF_TRIAL_MESSAGE_AUDIENCES)[preDunningDaysLeft];
    return undefined;
};

});



//# sourceMappingURL=async-end-of-trial-message-shared.21de72dd.js.map
